import { HELP_LINK, USER_ACTION } from 'constants/mixpanel';

export type LinkButtonKey =
  | 'help-center'
  | 'keyboard-shortcuts'
  | 'email-us'
  | 'chat-with-us'
  | 'my-designs'
  | 'my-account'
  | 'sign-out'
  | 'feedback';

/**
 * Maps a given key to its corresponding Mixpanel tracking key.
 * This function is used for handling the analytics tracking of different link button actions.
 *
 * @param {string} key - The key associated with a specific link or user action.
 * This should correspond to one of the predefined keys in the HELP_LINK or USER_ACTION objects.
 *
 * @returns {string} Returns the Mixpanel tracking key if found.
 */
const handleLinkButtonMixpanelKey = (key: LinkButtonKey) => {
  switch (key) {
    case 'help-center':
      return HELP_LINK.from.helpCenter;
    case 'keyboard-shortcuts':
      return HELP_LINK.from.keyboardShortcuts;
    case 'email-us':
      return HELP_LINK.from.emailUs;
    case 'chat-with-us':
      return HELP_LINK.from.chatWithUs;
    case 'my-designs':
      return USER_ACTION.from.myDesigns;
    case 'my-account':
      return USER_ACTION.from.myAccount;
    case 'sign-out':
      return USER_ACTION.from.signOut;
    default:
      return;
  }
};

export { handleLinkButtonMixpanelKey };
